var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveClone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.01 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_bez_okraje"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.49,3.51C15.8-1.17,8.2-1.17,3.51,3.51-1.18,8.19-1.17,15.8,3.51,20.48c4.68,4.68,12.29,4.68,16.97,0,4.68-4.68,4.68-12.29,0-16.97h.01ZM4.93,19.07c-3.9-3.9-3.9-10.25,0-14.14s10.25-3.9,14.14,0c3.89,3.9,3.9,10.25,0,14.14-3.9,3.9-10.25,3.9-14.14,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Black_bez_okraje-2",
    "data-name": "Black_bez_okraje"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.49,3.51C19.8-1.17,12.2-1.17,7.51,3.51c-4.69,4.68-4.68,12.29,0,16.97,4.68,4.68,12.29,4.68,16.97,0,4.68-4.68,4.68-12.29,0-16.97h.01ZM8.93,19.07c-3.9-3.9-3.9-10.25,0-14.14s10.25-3.9,14.14,0c3.89,3.9,3.9,10.25,0,14.14-3.9,3.9-10.25,3.9-14.14,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.43,11.96c0-.55-.45-1-1-1h-3.44v-3.44c0-.55-.45-1-1-1s-1,.45-1,1v3.44h-3.44c-.55,0-1,.45-1,1,0,.28.11.52.3.71s.43.29.71.3h3.44v3.44c0,.28.11.52.3.71s.43.29.71.3c.55,0,1-.45,1-1v-3.44h3.44c.55,0,1-.45,1-1h-.01v-.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveClone);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-clone.49ea2902060ed3848ce2720b925a9388.svg";
export { ForwardRef as ReactComponent };